import React from 'react';
import * as _ from 'lodash';

export function CustomerDataColumnFormatter(cellContent) {
  const fullName = _.get(cellContent, 'customer.name', '');
  const email = _.get(cellContent, 'customer.email', '');

  return (
    <>
      <div className="text-dark-75 font-weight-bolder font-size-lg">
        {fullName}
      </div>
      <div className="text-dark-75 font-weight-bolder font-size-lg">
        {email}
      </div>
    </>
  );
}
